import { render, staticRenderFns } from "./SwiperConfig.vue?vue&type=template&id=c25468ce&"
import script from "./SwiperConfig.vue?vue&type=script&lang=js&"
export * from "./SwiperConfig.vue?vue&type=script&lang=js&"
import style0 from "./SwiperConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports